if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
 }


// WEBPACK FOOTER //
// ./scripts/polyfill/nodelist-foreach.js